
import Brands from '@/graphql/queries/taxonomy/Brands'

export default {
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: Brands
    })

    this.brands = data.brands
  },
  data() {
    return {
      brands: null
    }
  },
  methods: {
    detailsLink({ slug }) {
      const route = `brands/${slug}`
      return this.$pagePath(route)
    }
  }
}
